import * as React from 'react';
import { BrowserType } from '../../wui-core/src/types/iCore';
import { BrowserContextProps } from './iProvider';

const BrowserContext = React.createContext(true as BrowserType);

// eslint-disable-next-line react/prop-types
export const BrowserContextProvider: React.FC<BrowserContextProps> = ({children, browser}) => (
    <BrowserContext.Consumer>
        {originBrowser => (
            <BrowserContext.Provider value={browser || originBrowser}>{children}</BrowserContext.Provider>
        )}
    </BrowserContext.Consumer>
);

export default BrowserContext;
